export default {
    data() {
        return {
            stageList: [
                {
                    title: '第一阶段',
                    desc: 'Java SE核心知识',
                    direct: 'right',
                    index: 1,
                    detail: [
                        {
                            title: 'Java编程概述及基础语法',
                            content: [
                                'Java技术体系平台',
                                'Java核心机制与JVM运行原理',
                                'Java开发环境搭建',
                                'Java变量、数据类型、数组及运算符',
                                'Java流程控制结构',
                                '面向对象编程',
                                '高级类特性',
                                'Java API、异常机制、反射及IO流',
                                'Lambda表达式',
                                '函数式接口',
                            ],
                        },
                        {
                            title: 'Java集合与泛型',
                            content: [
                                '集合框架概述',
                                'Collection 系列集合',
                                'List系列集合与Set系列集合',
                                'Iterator 与 ListIterator',
                                'Collections 工具类',
                                '集合中使用泛型',
                                '自定义泛型',
                            ],
                        },
                        {
                            title: 'Java多线程技术',
                            content: [
                                '线程的原理',
                                '线程的创建与启动',
                                '创建线程的几种方式对比',
                                '继承 Thread 类与实现 Runnable 接口',
                                '创建线程方式对比',
                                '线程的控制',
                                '线程的调度',
                                '线程的优先级',
                                '线程的生命周期',
                                '多线程的安全问题与解决办法',
                                '线程的同步',
                                '互斥锁',
                                '线程的死锁问题',
                                '线程通信',
                                '生产者与消费者案例',
                            ],
                        },
                        {
                            title: 'Java SE网路编程',
                            content: [
                                '网络编程基础知识',
                                '网络编程的主要问题',
                                '如何实现网络中主机的相互通讯',
                                '网络通讯要素',
                                '网络通信协议',
                                'OSI参考模型',
                                'TCP/IP参考模型(或TCP/IP协议)',
                                '数据的封装与拆封',
                                'Java.net.InetAddress 类',
                                'TCP 协议与UDP协议',
                                '基于TCP协议的网络编程',
                                'Socket 的TCP编程',
                                '基于UDP协议的网络编程',
                                'URL编程',
                                '针对HTTP协议的URLConnection',
                            ],
                        },
                    ],
                },
                {
                    title: '第二阶段',
                    desc: 'Java Web数据可视化',
                    direct: 'right',
                    index: 2,
                    detail: [
                        {
                            title: 'Java Web 后端技术',
                            content: [
                                'Tomcat&Nginx服务器中间件',
                                'Servlet规范组件',
                                'Ajax&Json轻量级数据交互',
                                'Maven项目构建工具',
                                'Preformance 工具的使用及注意事项',
                                'Git项目协作工具',
                                'Spring依赖管理框架',
                                'SpringMVC表现层框架',
                                'Mybatis持久层框架',
                                '分布式架构理论',
                            ],
                        },
                        {
                            title: '前端可视化技术',
                            content: [
                                'XML可扩展标记语言',
                                'HTML、CSS、JavaScript静态化技术',
                                'Jquery、Vue脚本框架',
                                'ECharts可视化组件',
                                'FusionCharts可视化组件',
                            ],
                        },
                        {
                            title: '关系型数据库MySQL高级应用',
                            content: [
                                'MySQL基础',
                                'MySQL数据库对象',
                                'SQL结构化查询语言',
                                'JDBC操作',
                                'MySQL查询和慢查询日志分析',
                                'MySQL调优之索引优化',
                                'MySQL调优之存储引擎优化',
                                'MySQL调优之锁机制优化',
                                'MySQL高可用',
                            ],
                        },
                        {
                            title: 'Linux 服务器应用实战',
                            content: [
                                'Linux系统基础',
                                'Linux网络基础',
                                'Linux安全策略',
                                'Shell编程基础及应用',
                                'Linux运维技巧',
                            ],
                        },
                        {
                            title: '拉勾招聘行业报表数据可视化项目实战',
                            content: [],
                        },
                    ],
                },
                {
                    title: '第三阶段',
                    index: 3,
                    desc: 'Hadoop核心及生态圈技术栈',
                    direct: 'right',
                    detail: [
                        {
                            title: 'Hadoop核心之分布式文件系统HDFS',
                            content: [
                                '大数据概述',
                                'Hadoop概述',
                                'Apache Hadoop完全分布式集群部署',
                                'HDFS简介及应用场景',
                                'HDFS原理详解',
                                'HDFS Shell 操作',
                                'HDFS Java API 操作',
                                'HDFS原理输入及调优',
                                '双缓冲机制',
                                'HDFS源码剖析、设计模式及二次开发',
                            ],
                        },
                        {
                            title: 'Hadoop核心之分布式计算框架MapReduce',
                            content: [
                                'MapReduce设计目标及核心思想',
                                'MapReduce主要功能',
                                'MapReduce处理流程',
                                'MapReduce入门案例',
                                'Mapper抽象类与Reducer抽象类',
                                'MapReduce内置数据类型及自定义数据类型',
                                '如何确定Map和Reduce个数',
                                'MapReduce Shuffle过程之Combine合并机制',
                                'MapReduce Shuffle过程之Partition分区机制、自定义分区',
                                'MapReduce Shuffle之序列化',
                                'MapReduce Shuffle过程之自定义排序及二次排序',
                                'MapReduce Shuffle过程之数据压缩机制',
                                '自定义InputFormat及OutputFormat',
                                'MapReduce生产级调优',
                                'MapReduce案例实战',
                            ],
                        },
                        {
                            title: 'Hadoop核心之分布式资源调度框架Yarn',
                            content: [
                                '分布式资源调度及Yarn简介',
                                'Yarn架构及原理',
                                'Yarn核心组件之ResourceManager 资源管理器',
                                'Yarn核心组件之NodeManager 节点管理器',
                                'Yarn核心组件之Application Master 任务专员',
                                'Yarn核心组件之Container 容器',
                                'Yarn资源调度FIFO策略和应用',
                                'Yarn资源调度Fair策略和应用',
                                'Yarn资源调度Capacity策略和应用',
                                'Yarn多租户资源调度配置',
                                'Yarn生产级调优',
                            ],
                        },
                        {
                            title: 'Hadoop生态圈技术栈（上）',
                            content: [
                                '数据仓库Hive高级应用',
                                'ETL转换抽取工具Sqoop',
                                'ETL转换抽取工具CDC',
                                'ETL转换抽取工具DataX',
                                '数据采集工具Flume',
                                '分布式协调服务组件ZooKeeper',
                                '海量列式非关系型数据库HBase',
                            ],
                        },
                        {
                            title: 'Hadoop生态圈技术栈（下）',
                            content: [
                                '海量列式非关系型数据库HBase',
                                'SQL语义级查询系统Impala',
                                '任务调度组件Oozie',
                                '任务调度组件Azkaban',
                                '任务调度组件airflow',
                            ],
                        },
                    ],
                },
                {
                    title: '第四阶段',
                    index: 4,
                    desc: '分布式缓存Redis及Kafka消息中间件',
                    direct: 'bottom',
                    detail: [
                        {
                            title: '高性能分布式缓存Redis',
                            content: [
                                'NoSQL&Redis入门',
                                '分布式数据库CAP原理',
                                'Redis五大数据类型和基本操作命令',
                                'Redis总体配置Redis.conf',
                                'Redis持久化（RDB和AOF）',
                                'Redis事务控制',
                                'Redis发布和订阅',
                                'Redis（Master/Slave）主从复制',
                                'Java客户端Jedis',
                                '通讯协议及事件处理机制',
                                'Redis + Lua环境协作组件',
                                'Redis慢查询及监视器',
                            ],
                        },
                        {
                            title: '高吞吐消息中间件Kafka',
                            content: [
                                'Kafka架构',
                                'Kafka安装及高级应用',
                                'Kafka生产者原理 ',
                                'Kafka broker端原理',
                                'Kafka 集群',
                                'Kafka消费者源码剖析',
                                'Kafka深度调优',
                                'Flume+Kafka整合应用',
                            ],
                        },
                    ],
                },
                {
                    title: '第五阶段',
                    index: 5,
                    desc: 'PB级电商离线数仓项目实战',
                    direct: 'bottom',
                    detail: [
                        {
                            title: '数仓分层建设及理论梳理',
                        },
                        {
                            title: '数仓建设痛点剖析',
                        },
                        {
                            title: '数据血缘管理机制',
                        },
                        {
                            title: '质量监控策略',
                        },
                        {
                            title: '离线数仓全流程性能优化方案',
                        },
                        {
                            title: '电商行业离线数仓业务真实级源码构建与剖析',
                        },
                    ],
                },
                {
                    title: '第六阶段',
                    index: 6,
                    desc: '内存级快速计算引擎Spark',
                    direct: 'left',
                    detail: [
                        {
                            title: 'Scala编程',
                            content: [
                                'Scala基础',
                                'Scala控制结构和函数',
                                'Scala数组相关操作',
                                'Scala映射和元组',
                                'Scala继承、特质、高阶函数',
                                'Scala集合',
                                'Scala模式匹配和样例类',
                                'Scala偏函数',
                                'Scala Future及类型参数 ',
                                'Scala 高级类型 ',
                                'Scala 隐式转换和隐式参数',
                            ],
                        },
                        {
                            title: 'Spark实战应用',
                            content: [
                                'Spark Core核心',
                                'Spark SQL结构化处理',
                                'Spark Streaming流处理',
                                'Spark GraphX图挖掘',
                                'Spark MLib机器学习',
                                'Spark综合案例实战',
                            ],
                        },
                    ],
                },
                {
                    title: '第七阶段',
                    index: 7,
                    desc: '智慧物流项目',
                    direct: 'left',
                    detail: [
                        {
                            title: '数据采集',
                            content: [
                                'Flume/Maxwell',
                            ],
                        },
                        {
                            title: '仓库缺货-销量预测',
                            content: [
                                'LigthGBM模型算法',
                            ],
                        },
                        {
                            title: '运输车辆调度',
                            content: [
                                '动态规划算法',
                            ],
                        },
                        {
                            title: '车辆位置/指标实时监控',
                            content: [
                                '实时指标Redis存储',
                                'SparkStreaming消费一致性，Exactly Once解决方案',
                            ],
                        },
                        {
                            title: '轨迹回放',
                            content: [
                                'HBase海量历史数据存储',
                                'HBase应用及优化',
                            ],
                        },
                        {
                            title: '多维度业务指标看板',
                            content: []
                        },
                    ],
                },
                {
                    title: '第八阶段',
                    index: 8,
                    desc: '实时计算领域最锋利的武器Flink',
                    direct: 'left',
                    detail: [
                        {
                            title: 'Flink基础',
                            content: [
                                'Flink 的应用场景和架构模型',
                                'Flink 入门程序 WordCount 和 SQL 实现',
                                'Flink 的编程模型与其他框架比较',
                                'Flink 常用的 DataSet 和 DataStream API',
                                'Flink SQL & Table 编程和案例',
                                'Flink 集群安装部署和 HA 配置',
                            ],
                        },
                        {
                            title: 'Flink进阶',
                            content: [
                                'Flink 常见核心概念分析',
                                'Flink 窗口、时间和水印',
                                'Flink 状态与容错',
                                'Flink Side OutPut 分流',
                                'Flink CEP 复杂事件处理',
                                'Flink 常用的 Source 和 Connector',
                            ],
                        },
                        {
                            title: 'Flink高级实践及调优',
                            content: [
                                'Flink 高可用配置',
                                'Flink Exactly-once 实现原理解析',
                                'Flink反压问题排查',
                                'Flink数据倾斜问题处理',
                                'Flink并行度和资源设置',
                                'Flink生产环境作业监控',
                                'Flink维表关联方案',
                                'Flink海量数据高效去重',
                                'Flink与Kafka的整合',
                                'Flink 中 watermark 的定义和使用',
                                'Flink 中的聚合函数和累加器的设计和使用',
                                '自定义消息事件及Pattern ',
                            ],
                        },
                        {
                            title: 'Flink综合案例实战',
                        },
                    ],
                },
                {
                    title: '第九阶段',
                    index: 9,
                    desc: '大数据新技术实践',
                    direct: 'left',
                    detail: [
                        {
                            title: 'OLAP列式数据库管理系统ClickHouse',
                            content: [
                                'ClickHouse简介及应用场景',
                                'ClickHouse架构及原理',
                                'ClickHouse数据类型',
                                'ClickHouse列设计',
                                'ClickHouse物化列&表达式列',
                                'ClickHouse实战案例',
                            ],
                        },
                        {
                            title: '新型列式存储分布式数据库Kudu',
                            content: [
                                'Kudu 简介及应用场景',
                                'Kudu 的高层设计 ',
                                'Kudu 中的角色',
                                'Kudu 中的概念与机制',
                                'Kudu 安装部署',
                                'Kudu 管理',
                                'Kudu操作接口',
                                'Kudu性能调优',
                                'Kudu实战案例',
                            ],
                        },
                        {
                            title: '开源的分布式分析引擎Kylin',
                            content: [
                                'Kylin的工作原理',
                                'Kylin的技术架构',
                                'Kylin的主要特点',
                                'Kylin快速入门',
                                'Cube优化',
                                '增量构建',
                                '查询和可视化',
                                'Cube Planner及仪表盘',
                                '流式构建',
                                'Kylin实战案例',
                            ],
                        },
                        {
                            title: '实时统计分析开源数据存储Druid',
                            content: [
                                'Druid原理及部署',
                                'Druid数据摄入',
                                'Druid客户端',
                                'Druid实战案例',
                            ]
                        },
                    ],
                },
                {
                    title: '第十阶段',
                    index: 10,
                    desc: 'Elastic Stack 日志搜索、挖掘及可视化解决方案',
                    direct: 'left',
                    detail: [
                        {
                            title: 'Elasticsearch全文搜索引擎',
                            content: [
                                '认识全文搜索引擎',
                                '倒排索引机制',
                                '全文搜索引擎Elasticsearch介绍',
                                'Elasticsearch Single-Node Mode快速部署',
                                'Elasticsearch之入门使用',
                                'Elasticsearch之高级应用',
                                'Elasticsearch之企业级高可用分布式集群',
                                'Elasticsearch之数据模型构建',
                                'Elasticsearch之拉勾亿级数据量搜索实战',
                                'Elasticsearch之深度应用及原理剖析',
                                'Elasticsearch 7.x分布式集群调优策略',
                            ],
                        },
                        {
                            title: 'Logstash采集、Kibana展示方案',
                            content: [
                                'Intput插件应用及原理',
                                '自定义Intput插件',
                                'Filter插件',
                                '自定义Filter过滤插件',
                                'Output插件应用及原理',
                                '自定义Output插件',
                                'Kibana可视化组件',
                                '多维可视化展示实战',
                            ],
                        },
                    ],
                },
                {
                    title: '第十一阶段',
                    index: 11,
                    desc: '电商行业实时数仓项目',
                    direct: 'left',
                    detail: [
                        {
                            title: 'Flink流式处理技术构建复杂的电商订单指标',
                        },
                        {
                            title: 'ClickHouse快速电商业务查询',
                        },
                        {
                            title: '数据完整处理链条展现',
                        },
                        {
                            title: '电商大促峰值数据大数据解决方案',
                        },
                    ],
                },
                {
                    title: '第十二阶段',
                    index: 12,
                    desc: 'Hadoop/Spark大数据处理算法及案例',
                    direct: 'left',
                    detail: [
                        {
                            title: '大数据处理算法及案例（上）',
                            content: [
                                'K-均值算法',
                                'KNN算法',
                                '朴素贝叶斯',
                                '马尔可夫链',
                                '推荐算法',
                                '成对文档相似性',
                                '算法案例实战应用',
                            ]
                        },
                        {
                            title: '大数据处理算法及案例（下）',
                            content: [
                                '线性回归',
                                'Cox回归',
                                '皮尔逊（Pearson）相关分析',
                                '社交网络分析之推荐系统',
                                '社交网络分析之三角形计数',
                                '社交网络分析之情感分析',
                                '算法案例实战应用',
                            ]
                        },
                    ],
                },
                {
                    title: '第十三阶段',
                    index: 13,
                    desc: '机器学习',
                    direct: 'left',
                    detail: [
                        {
                            title: 'Python 编程核心',
                            content: [
                                '交互式解释器',
                                'Python基础语法',
                                'Python面向对象',
                                'Python数据结构',
                                'Anaconda工具使用',
                            ]
                        },
                        {
                            title: 'Python编程实战',
                            content: [
                                'PySpark',
                                'Python与SparkSql整合',
                                'Python与SparkStreaming整合',
                                'Python+SparkMllib机器学习实战项目',
                            ]
                        },
                    ],
                },
                {
                    title: '第十四阶段',
                    index: 14,
                    desc: '人才用户画像匹配系统',
                    direct: 'left',
                    detail: [
                        {
                            title: '用户建模确定特征维度',
                        },
                        {
                            title: '标签分类及标签库设计',
                        },
                        {
                            title: 'ETL计算',
                        },
                        {
                            title: '特征处理',
                        },
                        {
                            title: '推荐算法模型处理，人才和企业精准对接',
                        },
                    ],
                },
            ],
            targetTime: '2019/12/10',
        };
    },
    methods: {
        formatTime(second) {
            let day = Math.floor(second / 86400);
            let hour = Math.floor(second % 86400 / 3600);
            let minute = Math.floor(second % 86400 % 3600 / 60);
            let sec = Math.floor(second % 86400 % 3600 % 60);
            let obj = {
                day,
                hour,
                minute,
                sec,
            };
            day = day > 0 ? `${day}天` : '';
            hour = hour >= 10 ? `${hour}小时` : `0${hour}小时`;
            minute = minute >= 10 ? `${minute}分钟` : `0${minute}分钟`;
            sec = sec >= 10 ? `${sec}秒` : `0${sec}秒`;

            return `剩余${day}${hour}${minute}${sec}`;
        },
        pureFormatTime(second) {
            let day = Math.floor(second / 86400);
            let hour = Math.floor(second % 86400 / 3600);
            let minute = Math.floor(second % 86400 % 3600 / 60);
            let sec = Math.floor(second % 86400 % 3600 % 60);
            const _prefix = (num) => (num > 9 ? num : `0${num}`);
            return {
                day: _prefix(day),
                hour: _prefix(hour),
                minute: _prefix(minute),
                sec: _prefix(sec),
            };
        },
    },
};
